<template>
  <el-card class="box-card mb-3">
    <div slot="header" class="clearfix">
      <span>{{ subject.title }}</span>
      <el-button
        type="danger"
        style="float: right;"
        size="mini"
        icon="el-icon-delete"
        circle
        @click="onRemoveSubject"
      ></el-button>
    </div>
    <div>
      <el-form :label-position="`top`" label-width="100px" size="mini">
        <el-form-item label="Title">
          <el-col :span="16">
            <el-input v-model="subject.title" type="text"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="Is Required?">
          <el-col :span="19">
            <el-radio-group v-model="subject.required">
              <el-radio :label="true">True</el-radio>
              <el-radio :label="false">False</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="Allow Duplicate?">
          <el-col :span="19">
            <el-radio-group v-model="subject.duplicate">
              <el-radio :label="true">True</el-radio>
              <el-radio :label="false">False</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="Image Size?">
          <el-col :span="19">
            <el-radio-group v-model="subject.imageSize">
              <el-radio :label="`none`">None</el-radio>
              <el-radio :label="`small`">Small</el-radio>
              <el-radio :label="`large`">Large</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
      </el-form>
      <div class="mt-4">
        <el-table :data="subject.items" stripe style="width: 100%">
          <el-table-column
            prop="name"
            label="Item"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="price"
            label="Price"
            width="80"
          ></el-table-column>
          <el-table-column prop="cog" label="COG" width="80"></el-table-column>
          <el-table-column label>
            <template slot-scope="scope">
              <el-button
                type="info"
                size="mini"
                icon="el-icon-edit"
                circle
                @click.native.prevent="onItemEdited(scope.$index)"
              ></el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.native.prevent="onItemRemoved(scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-button type="primary" size="mini" @click="onAddItemDialog"
            >Add New Item</el-button
          >
        </div>
      </div>
    </div>

    <v-dialog v-model="newDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>New Item</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 350px;">
          <el-form :label-position="`top`" label-width="100px" size="mini">
            <el-form-item label="Title">
              <el-col :span="16">
                <el-input v-model="itemTemplate.name" type="text"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="Extra Price">
              <el-col :span="16">
                <el-input v-model="itemTemplate.price" type="text"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="COG">
              <el-col :span="16">
                <el-input v-model="itemTemplate.cog" type="text"></el-input>
              </el-col>
            </el-form-item>
          </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="newDialog = false"
            >Close</v-btn
          >
          <v-btn color="blue darken-1" flat @click="onItemAdded">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </el-card>
</template>

<script>
import moment from "moment";
export default {
  name: "customise-subject",
  props: ["product_id", "subject"],
  data() {
    return {
      newDialog: false,
      itemTemplate: {
        name: "",
        price: 0,
        cog: 0,
      },
    };
  },
  methods: {
    onRemoveSubject() {
      this.$emit("remove");
    },
    onItemEdited(index) {},
    onItemRemoved(index) {
      this.subject.items.splice(index, 1);
    },
    onAddItemDialog() {
      this.newDialog = true;
    },
    onItemAdded() {
      let id = "i" + moment().format("X");

      if (this.subject.duplicate) {
        this.subject.items.push({ ...this.itemTemplate, id: id, quantity: 0 });
      } else {
        this.subject.items.push({
          ...this.itemTemplate,
          id: id,
          checked: false,
        });
      }

      this.newDialog = false;
      this.itemTemplate = {
        name: "",
        price: 0,
        cog: 0,
      };
    },
  },
};
</script>

<style scoped></style>
